export default __webpack_public_path__ + "images/navidial_logo.svg";